import './ReportDetailItem.scss';

import AppCard from '../../../commons/cards/AppCard';
import { useNavigate } from 'react-router-dom';

function ReportDetailItem({ name, path, icon }) {
  const navigate = useNavigate();
  const redirect = () => navigate(`/${path}`);

  return (
    <AppCard className="report-item-card">
      <button
        type="button"
        className="report-item-card__button"
        onClick={redirect}
        aria-label={`Abrir relatório: ${name}`}
      >
        {icon && <div className="report-item-card__icon">{icon}</div>}
        <div className="report-item-card__body">
          <h5 className="report-item-card__title">{name}</h5>
          <p className="report-item-card__desc">Clique para visualizar o relatório</p>
        </div>
      </button>
    </AppCard>
  );
}

export default ReportDetailItem;